import { formatUpdatedAt } from '../../allBrands/mappers/brandCatalogMapper'
import { formatStatus } from '../../allBrands/mappers/brandCatalogMapper'
import {
  DOCUMENT_STATUS_LABELS,
  getDocumentStatusLabel,
} from '../config/brandDetailsConfig'
import { formatFileSize } from '../mappers/brandDocumentMapper'

// Every document uploaded for the brand, as its latest version reads.
const KnowledgeBaseView = ({ documents, isLoading }) => {
  if (documents.length === 0) {
    return (
      <p className="draft-review__empty">
        {isLoading ? 'Loading documents…' : 'No documents uploaded yet.'}
      </p>
    )
  }

  return (
    <section aria-label="Knowledge Base" className="knowledge-base">
      <header>
        <h2>Knowledge Base</h2>
        <p>{documents.length} documents</p>
      </header>
      <table>
        <thead>
          <tr>
            <th scope="col">File name</th>
            <th scope="col">Size</th>
            <th scope="col">Version</th>
            <th scope="col">Status</th>
            <th scope="col">Uploaded by</th>
            <th scope="col">Uploaded on</th>
          </tr>
        </thead>
        <tbody>
          {documents.map((document) => (
            <tr key={document.id}>
              <td className="knowledge-base__file">{document.fileName}</td>
              <td>{formatFileSize(document.sizeBytes)}</td>
              <td>{document.versionNumber && `v${document.versionNumber}`}</td>
              <td>
                {DOCUMENT_STATUS_LABELS[document.brandDnaStatus] ||
                  formatStatus(document.brandDnaStatus) ||
                  getDocumentStatusLabel(document.status)}
              </td>
              <td>{document.uploadedBy || '—'}</td>
              <td>{formatUpdatedAt(document.uploadedAt)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  )
}

export default KnowledgeBaseView
